/* eslint-disable */
/*****************************************/
/* This file is automatically generated! */
/* Check static/build/css-to-js.js!      */
/*****************************************/

import _invert from "lodash/invert";

const COLOR = {
    "neutral-0": "#051a3c",
    "neutral-1": "#1a2d4d",
    "neutral-2": "#2f415e",
    "neutral-3": "#45546e",
    "neutral-4": "#5a687f",
    "neutral-5": "#6f7b90",
    "neutral-6": "#8a93a5",
    "neutral-7": "#a4acba",
    "neutral-8": "#bfc4cf",
    "neutral-9": "#d9dde4",
    "neutral-10": "#f4f5f9",
    "blue-0": "#121947",
    "blue-1": "#1b266c",
    "blue-2": "#233390",
    "blue-3": "#2c40b5",
    "blue-4": "#344dd9",
    "blue-5": "#3d5afe",
    "blue-6": "#6178fe",
    "blue-7": "#8497fe",
    "blue-8": "#a8b5ff",
    "blue-9": "#cbd4ff",
    "blue-10": "#eff2ff",
    "green-0": "#002420",
    "green-1": "#003731",
    "green-2": "#004b42",
    "green-3": "#015e54",
    "green-4": "#017265",
    "green-5": "#018576",
    "green-6": "#13aa88",
    "green-7": "#5fb2a8",
    "green-8": "#8dc8c2",
    "green-9": "#bcdfdb",
    "green-10": "#ebf5f4",
    "yellow-0": "#2b1f03",
    "yellow-1": "#523c09",
    "yellow-2": "#79590e",
    "yellow-3": "#9f7514",
    "yellow-4": "#c69219",
    "yellow-5": "#edaf1f",
    "yellow-6": "#f0be48",
    "yellow-7": "#f4cd71",
    "yellow-8": "#f7db9b",
    "yellow-9": "#fbeac4",
    "yellow-10": "#fef9ed",
    "orange-0": "#2e0f04",
    "orange-1": "#53200d",
    "orange-2": "#783016",
    "orange-3": "#9e4120",
    "orange-4": "#c35129",
    "orange-5": "#e86232",
    "orange-6": "#ed7f57",
    "orange-7": "#f19c7d",
    "orange-8": "#f6b8a2",
    "orange-9": "#fad5c8",
    "orange-10": "#fff2ed",
    "red-0": "#290406",
    "red-1": "#4a0c10",
    "red-2": "#6b151b",
    "red-3": "#8c1d25",
    "red-4": "#ad2630",
    "red-5": "#ce2e3a",
    "red-6": "#d7545e",
    "red-7": "#e07b82",
    "red-8": "#e9a1a7",
    "red-9": "#f2c8cb",
    "red-10": "#fbeeef",
    black: "#000",
    white: "#fff",
    "white-87": "rgba(255, 255, 255, 0.87)",
    "white-70": "rgba(255, 255, 255, 0.7)",
    "white-60": "rgba(255, 255, 255, 0.6)",
    "white-32": "rgba(255, 255, 255, 0.32)",
    "white-24": "rgba(255, 255, 255, 0.24)",
    "white-12": "rgba(255, 255, 255, 0.12)",
    "white-8": "rgba(255, 255, 255, 0.08)",
    "white-4": "rgba(255, 255, 255, 0.04)",
    "ai-highlight": "#7b61ff26",
    "ai-emphasis": "#7b61ff80",
    "navy-black": "#051a3c",
    "navy-high": "#162d54",
    "navy-medium": "#5e6785",
    "navy-low": "#9caac0",
    "navy-grey": "#c2cad7",
    "navy-light-grey": "#d8dde6",
    "navy-lighter-grey": "#eff1f6",
    "navy-lightest-grey": "#f4f5f9",
    "navy-background": "#fafbfb",
    "navy-medium-8": "#051a3c14",
    "indigo-dark": "#0031ca",
    indigo: "#3d5afe",
    "indigo-light": "#8187ff",
    "indigo-92": "#4d67fe",
    "indigo-76": "#6c82fe",
    "indigo-68": "#7b8ffe",
    "indigo-32": "#c1caff",
    "indigo-24": "#d0d7ff",
    "indigo-16": "#e0e5ff",
    "indigo-8": "#eff2ff",
    "indigo-4": "#f7f8ff",
    "indigo-light-fade-24": "rgba(129, 135, 255, 0.24)",
    "indigo-fade-24": "rgba(61, 90, 254, 0.24)",
    "indigo-fade-8": "rgba(61, 90, 254, 0.08)",
    "indigo-fade-4": "rgba(61, 90, 254, 0.04)",
    "teal-dark": "#009976",
    teal: "#00cba5",
    "teal-light": "#60ffd6",
    "teal-12": "#e0f9f4",
    "light-teal": "#f4fcfa",
    red: "#ce2e3a",
    "light-red": "#fbeeef",
    "dark-red": "#a4242e",
    "darker-red": "#8f2028",
    "red-orange": "#e86232",
    yellow: "#edaf1f",
    "mid-yellow": "#f7d37f",
    "light-yellow": "#fef9ed",
    "medium-green": "#13aa88",
    green: "#018576",
    "light-green": "#ebf5f4",
    "green-50": "#80c2bb",
    "medium-green-50": "#89d5c4",
    "medium-green-25": "#c4eae1",
    "yellow-50": "#f6d78f",
    "red-orange-50": "#f4b199",
    "red-50": "#e7979c",
    "space-grey": "#4a4a4a",
    "demon-grey": "#666",
    "slate-grey": "#9b9b9b",
    "mid-grey": "#bbb",
    "light-grey": "#ddd",
    "lightest-grey": "#f5f5f5",
    "hover-grey": "#f9f9f9",
    "cover-background": "rgba(0, 0, 0, 0.5)",
    "yellow-70": "rgba(237, 175, 31, 0.7)",
    "adp-red": "#e51938",
};

export default COLOR;

export const COLOR_LOOKUP = _invert(COLOR);
